import type moment from "moment-timezone";

export const snapTimeTo15Minutes = (time: moment.Moment) => {
    const minutes = time.minutes();
    const remainder = minutes % 15;
    if (remainder > 7.5) {
        return time
            .clone()
            .add(15 - remainder, "minutes")
            .second(0)
            .millisecond(0);
    } else {
        return time.clone().subtract(remainder, "minutes").second(0).millisecond(0);
    }
};
